module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "36",
      "height": "36",
      "viewBox": "0 0 36 36"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "18",
      "cy": "18",
      "r": "18",
      "fill": _vm.globalColors.primary,
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M9 6h19v23H9z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "fill": _vm.globalColors.primary,
      "font-family": "AvenirNext-Bold, Avenir Next",
      "font-size": "10",
      "font-weight": "bold",
      "transform": "translate(9 6)"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "6.27",
      "y": "11"
    }
  }, [_vm._v("$")])]), _vm._v(" "), _c('path', {
    attrs: {
      "stroke": _vm.globalColors.primary,
      "stroke-linecap": "square",
      "d": "M13.5 21.5h10M13.5 24.25h10"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76eed710","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg-components/billingBuyCar.vue
// module id = 1140
// module chunks = 33